<template>
  <div>
    <base-box
      :queryFormList="formList"
      :total="total"
      :loading="loading"
      :queryFormDefault="queryFormDefault"
      @getList="getList"
    >
      <template v-slot:headerPosition>
        <jr-select
          title="单据类型"
          v-model="queryForm.finType"
          :size="formSize"
          @change="refreshList"
          dictionary-type="PAY_FIN_TYPE"
          select-style="max-width: 150px"
        />
      </template>
      <template v-slot:mainTable="{height}">
        <el-table
          border
          row-class-name="table-row"
          header-row-class-name="table-header-cell"
          :data="list"
          v-loading="loading"
          :height="height"
          :key="height"
        >
          <el-table-column width="150">
            <el-table-column prop="batchNo" label="对账批次号" min-width="1" />
          </el-table-column>
          <el-table-column label="财务系统数据" align="center">
            <el-table-column prop="merchantName" label="对账主体" min-width="1" />
            <el-table-column label="账单日期" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.countingDate | formatTime('yyyy-MM-dd')}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="requestNo" label="上游渠道号" min-width="1" />
            <el-table-column prop="orderNo" label="业务订单号" min-width="1" />
            <el-table-column prop="finTradeAmount" label="金额(元)" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.finTradeAmount | toFenThousandsAndFloat('', 2, true)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="手续费(元)" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.finFeeAmount | toFenThousandsAndFloat('', 2, true)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="交易时间" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.finTradeTime | formatTime}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="finTypeDesc" label="单据类型" min-width="1" />
          </el-table-column>
          <el-table-column label="渠道交易数据" align="center">
            <el-table-column prop="thirdRequestNo" label="商户订单号" min-width="1" />
            <el-table-column prop="remake" label="备注" min-width="1" />
            <el-table-column label="交易金额(元)" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.thirdTradeAmount | toFenThousandsAndFloat('', 2, true)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="渠道手续费(元)" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.thirdFeeAmount | toFenThousandsAndFloat('', 2, true)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="交易时间" min-width="1">
              <template slot-scope="{row}">
                <div>{{row.thirdFinishTime | formatTime}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="状态" prop="statusDesc" min-width="1" />
          <el-table-column label="操作" width="120">
            <template slot-scope="{row}">
              <el-button type="text" @click="handleClick(row)" v-if="row.status === 1 && $has('FWS-DZZX-YCCLDF-CK')">查看</el-button>
              <el-button type="text" @click="handleClick(row)" v-if="row.status === 0 && $has('FWS-DZZX-YCCLDF-CL')">处理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </base-box>

    <operate-dialog
      :visible.sync="isShow"
      fileType="ybPay"
      :currentObj="currentRow"
      :isModify="currentRow.status === 1"
      @success="getList"
    />
  </div>
</template>

<script>
import baseBox from '../components/base-box';
import { getPayDiffList } from '@/api/counting';
import operateDialog from './components/operate-dialog';

export default {
  name: 'CheckDiffPayment',
  components: { baseBox, operateDialog },
  data() {
    return {
      queryFormDefault: {
        countingDateStart: '', // 开始时间
        countingDateEnd: '', // 结束时间
        page: 1,
        limit: 20,
        orderNo: '',
        merchantNo: '', // 对账主体
        finType: '',
      },
      formList: [
        {
          label: '业务订单号',
          name: 'orderNo',
          component: 'input',
        },
      ],
      loading: false,
      list: [],
      total: 0,
      isShow: false,
      currentRow: {},
      queryForm: {},
    };
  },
  methods: {
    async getList(params = {}) {
      try {
        this.loading = true;
        this.queryForm = { ...this.queryForm, ...params };
        const res = await getPayDiffList(this.queryForm);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.list = [];
        console.log(error);
      }
    },
    handleClick(row) {
      this.currentRow = { ...row };
      this.isShow = true;
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
  },
};
</script>
